// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSCarousel/index.less
// module id = 891
// module chunks = 42